{
  "aqua-coral": {
    "width": 133,
    "height": 73,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 133,
      "height": 73
    },
    "anchor": {
      "x": 66.5,
      "y": 73
    }
  },
  "aqua-ruin": {
    "width": 360,
    "height": 220,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 360,
      "height": 220
    },
    "anchor": {
      "x": 180,
      "y": 220
    }
  },
  "cellion": {
    "width": 35,
    "height": 43,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 35,
      "height": 43
    },
    "anchor": {
      "x": 17.5,
      "y": 43
    },
    "motionBounds": {
      "x": 0,
      "y": 0,
      "width": 35,
      "height": 43
    }
  },
  "cico": {
    "width": 50,
    "height": 70,
    "bounds": {
      "x": 2,
      "y": 0,
      "width": 46,
      "height": 70
    },
    "anchor": {
      "x": 25,
      "y": 70
    },
    "motionBounds": {
      "x": 0,
      "y": 0,
      "width": 50,
      "height": 70
    }
  },
  "ellinia-house": {
    "width": 600,
    "height": 365,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 600,
      "height": 365
    },
    "anchor": {
      "x": 300,
      "y": 365
    }
  },
  "ellinia-root": {
    "width": 152,
    "height": 117,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 152,
      "height": 117
    },
    "anchor": {
      "x": 76,
      "y": 117
    }
  },
  "ellinia-vine": {
    "width": 197,
    "height": 405,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 197,
      "height": 405
    },
    "anchor": {
      "x": 98.5,
      "y": 405
    }
  },
  "exp": {
    "width": 32,
    "height": 32,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 32,
      "height": 32
    },
    "anchor": {
      "x": 16,
      "y": 32
    }
  },
  "fairy-blessing": {
    "width": 32,
    "height": 32,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 32,
      "height": 32
    },
    "anchor": {
      "x": 16,
      "y": 32
    }
  },
  "hp": {
    "width": 27,
    "height": 30,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 27,
      "height": 30
    },
    "anchor": {
      "x": 13.5,
      "y": 30
    }
  },
  "kerning-graffiti": {
    "width": 256,
    "height": 123,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 256,
      "height": 123
    },
    "anchor": {
      "x": 128,
      "y": 123
    }
  },
  "kerning-pipe": {
    "width": 192,
    "height": 60,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 192,
      "height": 60
    },
    "anchor": {
      "x": 96,
      "y": 60
    }
  },
  "kerning-sign": {
    "width": 96,
    "height": 160,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 96,
      "height": 160
    },
    "anchor": {
      "x": 48,
      "y": 160
    }
  },
  "maple-leaf": {
    "width": 28,
    "height": 30,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 28,
      "height": 30
    },
    "anchor": {
      "x": 14,
      "y": 30
    }
  },
  "mesos": {
    "width": 32,
    "height": 32,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 32,
      "height": 32
    },
    "anchor": {
      "x": 16,
      "y": 32
    }
  },
  "mp": {
    "width": 27,
    "height": 30,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 27,
      "height": 30
    },
    "anchor": {
      "x": 13.5,
      "y": 30
    }
  },
  "mushroom-grass": {
    "width": 337,
    "height": 27,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 337,
      "height": 27
    },
    "anchor": {
      "x": 168.5,
      "y": 27
    }
  },
  "mushroom-house": {
    "width": 400,
    "height": 204,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 400,
      "height": 204
    },
    "anchor": {
      "x": 200,
      "y": 204
    }
  },
  "mushroom-stump": {
    "width": 43,
    "height": 42,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 43,
      "height": 42
    },
    "anchor": {
      "x": 21.5,
      "y": 42
    }
  },
  "mushroom": {
    "width": 63,
    "height": 61,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 63,
      "height": 58
    },
    "anchor": {
      "x": 31.5,
      "y": 58
    }
  },
  "octopus": {
    "width": 66,
    "height": 70,
    "bounds": {
      "x": 2,
      "y": 1,
      "width": 62,
      "height": 69
    },
    "anchor": {
      "x": 33,
      "y": 70
    },
    "motionBounds": {
      "x": 0,
      "y": 0,
      "width": 66,
      "height": 70
    }
  },
  "orbis-cloud": {
    "width": 401,
    "height": 150,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 401,
      "height": 150
    },
    "anchor": {
      "x": 200.5,
      "y": 150
    }
  },
  "orbis-ivy": {
    "width": 72,
    "height": 107,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 72,
      "height": 107
    },
    "anchor": {
      "x": 36,
      "y": 107
    }
  },
  "orbis-pavilion": {
    "width": 280,
    "height": 356,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 280,
      "height": 356
    },
    "anchor": {
      "x": 140,
      "y": 356
    }
  },
  "orbis-step": {
    "width": 302,
    "height": 58,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 302,
      "height": 58
    },
    "anchor": {
      "x": 151,
      "y": 58
    }
  },
  "pinkbean": {
    "width": 109,
    "height": 86,
    "bounds": {
      "x": 10,
      "y": 1,
      "width": 89,
      "height": 85
    },
    "anchor": {
      "x": 54.5,
      "y": 86
    },
    "motionBounds": {
      "x": 0,
      "y": 0,
      "width": 109,
      "height": 86
    }
  },
  "slime": {
    "width": 69,
    "height": 50,
    "bounds": {
      "x": 2,
      "y": 1,
      "width": 64,
      "height": 49
    },
    "anchor": {
      "x": 34,
      "y": 50
    },
    "motionBounds": {
      "x": 0,
      "y": 0,
      "width": 69,
      "height": 50
    }
  },
  "snow-ledge": {
    "width": 360,
    "height": 29,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 360,
      "height": 29
    },
    "anchor": {
      "x": 180,
      "y": 29
    }
  },
  "snow-pine": {
    "width": 118,
    "height": 180,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 118,
      "height": 180
    },
    "anchor": {
      "x": 59,
      "y": 180
    }
  },
  "snow-roof": {
    "width": 291,
    "height": 166,
    "bounds": {
      "x": 4,
      "y": 0,
      "width": 286,
      "height": 166
    },
    "anchor": {
      "x": 147,
      "y": 166
    }
  },
  "snow-supplies": {
    "width": 109,
    "height": 72,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 109,
      "height": 72
    },
    "anchor": {
      "x": 54.5,
      "y": 72
    }
  },
  "teddy": {
    "width": 84,
    "height": 51,
    "bounds": {
      "x": 17,
      "y": 2,
      "width": 55,
      "height": 49
    },
    "anchor": {
      "x": 44.5,
      "y": 51
    },
    "motionBounds": {
      "x": 0,
      "y": 0,
      "width": 84,
      "height": 51
    }
  },
  "temple-arch": {
    "width": 527,
    "height": 197,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 527,
      "height": 197
    },
    "anchor": {
      "x": 263.5,
      "y": 197
    }
  },
  "temple-garden": {
    "width": 222,
    "height": 127,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 222,
      "height": 127
    },
    "anchor": {
      "x": 111,
      "y": 127
    }
  },
  "temple-gate": {
    "width": 551,
    "height": 250,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 551,
      "height": 250
    },
    "anchor": {
      "x": 275.5,
      "y": 250
    }
  },
  "temple-hourglass": {
    "width": 140,
    "height": 106,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 140,
      "height": 106
    },
    "anchor": {
      "x": 70,
      "y": 106
    }
  },
  "temple-pillar": {
    "width": 78,
    "height": 236,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 78,
      "height": 236
    },
    "anchor": {
      "x": 39,
      "y": 236
    }
  },
  "time-eye": {
    "width": 52,
    "height": 54,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 52,
      "height": 54
    },
    "anchor": {
      "x": 26,
      "y": 54
    },
    "motionBounds": {
      "x": 0,
      "y": 0,
      "width": 52,
      "height": 54
    }
  },
  "toy-tower": {
    "width": 284,
    "height": 360,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 284,
      "height": 360
    },
    "anchor": {
      "x": 142,
      "y": 360
    }
  },
  "yeti": {
    "width": 69,
    "height": 63,
    "bounds": {
      "x": 12,
      "y": 22,
      "width": 44,
      "height": 41
    },
    "anchor": {
      "x": 34,
      "y": 63
    },
    "motionBounds": {
      "x": 0,
      "y": 0,
      "width": 69,
      "height": 63
    }
  },
  "zakum-altar": {
    "width": 448,
    "height": 58,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 448,
      "height": 58
    },
    "anchor": {
      "x": 224,
      "y": 58
    }
  },
  "zakum-emblem": {
    "width": 126,
    "height": 128,
    "bounds": {
      "x": 1,
      "y": 0,
      "width": 122,
      "height": 128
    },
    "anchor": {
      "x": 62,
      "y": 128
    }
  },
  "zakum-idol": {
    "width": 360,
    "height": 165,
    "bounds": {
      "x": 3,
      "y": 0,
      "width": 340,
      "height": 165
    },
    "anchor": {
      "x": 173,
      "y": 165
    }
  },
  "zakum-volcano": {
    "width": 212,
    "height": 240,
    "bounds": {
      "x": 0,
      "y": 0,
      "width": 212,
      "height": 240
    },
    "anchor": {
      "x": 106,
      "y": 240
    }
  }
}
